<script>
import WishlistPanel from '@phoenix/mixins/components/wishlist/WishlistPanel';
import Panel from '../common/Panel';
import ProductCard from '@maison/components/product/ProductCard';
import WishlistButton from '../wishlist/WishlistButton';
import ProductPrice from '@phoenix/components/common/ProductPrice';

export default {
  components: { Panel, ProductCard, ProductPrice, WishlistButton },

  mixins: [WishlistPanel],
};
</script>

<template>
  <panel
    id="wishlist-panel"
    :classes="['panel--lg-reverse']"
    reverse
    :title="$t('Wishlist.wishlistTitle')"
    :options="panelOptions"
  >
    <template v-if="isShownAndLoaded" #content>
      <ul v-if="products.length > 0" class="product-card-list" data-cy="wishlist-panel-products">
        <li
          v-for="product in products"
          :key="product.modelReference"
          data-cy="wishlist-panel-products-item"
          class="product-card-list__entry"
        >
          <ProductCard
            v-bind="product"
            :reference="product.modelReference"
            :sap-reference="product.sapReference"
            :horizontal="true"
            :vat-information="vatInformation(product.price)"
          >
            <template #price>
              <product-price v-bind="localizePrice(product.price)"></product-price>
            </template>
            <template #product-card-actions>
              <wishlist-button
                :reference="product.modelReference"
                :name="product.name"
                default-in-wishlist-icon="cross-16"
              />
            </template>
          </ProductCard>
        </li>
      </ul>
      <div v-else class="uppercase">
        {{ $t('Wishlist.emptyWishlist') }}
      </div>

      <template v-if="!isLogged">
        <hr class="divider" />

        <h5 class="mt-base">{{ $t('MyAccount.orCreateANewOne') }}</h5>
        <p class="mt-base text-sm">
          {{ $t('MyAccount.orCreateANewOneText') }}
        </p>
        <a
          type="button"
          class="btn btn--default btn--full btn--negative mt-base"
          :href="menuLinks.guestLinks.accountCreate"
        >
          <span class="btn__text pointer-events-none">{{ $t('MyAccount.createMyAccount') }}</span>
        </a>
      </template>

      <div v-if="isLoading" class="loader-overlay loader-overlay--light">
        <div class="loader loader--dark loader--lg">
          <div class="loader__inner"></div>
        </div>
      </div>
    </template>
    <template v-else #content>
      <div class="loader-overlay loader-overlay--light">
        <div class="loader loader--dark loader--lg">
          <div class="loader__inner"></div>
        </div>
      </div>
    </template>
  </panel>
</template>
